import { Icon, MenuItem, Select, SelectProps } from "@mui/material";
import * as React from "react";
import { useSetRecoilState } from "recoil";
import { useSaveData } from "../hooks/useSaveData";
import { USE_SELECTED_INDEX } from "../hooks/useSelectedElement";
import { useXPath } from "../hooks/useXPath";
import { TUrlPath } from "../utils/types/elements/XText.types";

const SwitchPage: React.FC<SelectProps> = (props) => {
  const { xPath, setXPath } = useXPath();
  const saveData = useSaveData();
  const setSelectedIndex = useSetRecoilState(USE_SELECTED_INDEX);

  const PAGES = [
    {
      field: "homePage",
      path: "/",
      name: "Page d'accueil",
      icon: "fi fi-rr-home",
    },
    {
      field: "categoriesPage",
      path: "/shop",
      name: "Boutique & Categories",
      icon: "fi fi-rr-shop",
    },
    {
      field: "aboutUsPage",
      path: "/about-us",
      name: "A propos",
      icon: "fi fi-rr-info",
    },
    {
      field: "contactPage",
      path: "/contact-us",
      name: "Contact",
      icon: "fi fi-rr-headset",
    },
    {
      field: "productDetailsPage",
      path: "/products/[slug]",
      name: "Informations d'article",
      icon: "fi fi-rr-shopping-bag",
    },
  ];

  return (
    <React.Fragment>
      <Select
        {...props}
        value={xPath}
        onChange={async (e) => {
          const path = e.target.value as TUrlPath;

          if (path === xPath) return;

          await saveData();

          setXPath(path);

          setSelectedIndex(null);

          const other = document.querySelectorAll("[data-x-selected]");

          if (other.length > 0) {
            other.forEach((e) => e.removeAttribute("data-x-selected"));
          }
        }}
      >
        {PAGES.map((page) => (
          <MenuItem
            selected={xPath === page.path}
            key={page.path}
            value={page.path}
            onClick={() => {}}
            sx={{
              alignItems: "center",
              display: "flex",

              "& .MuiIcon-root": {
                mr: 1,
              },
            }}
          >
            <Icon
              sx={{
                color: "primary.main",
                lineHeight: "1em",
                fontSize: 16,
                "&.material-icons": {
                  fontSize: "inherit",
                },
                "&::before": {
                  color: "inherit",
                  fontSize: "inherit",
                },
              }}
              className={page.icon}
            />
            {page.name}
          </MenuItem>
        ))}
      </Select>
    </React.Fragment>
  );
};

export default SwitchPage;
